<template>
  <div class="card coach-card">
    <div class="card-image">
      <figure class="image" v-bind:style="{ backgroundColor: coach.background_color }"> 
        <image-composite :background="background" 
                         :foreground="foreground"
        ></image-composite>
      </figure>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title is-5">{{coach.languages[0].pivot.name}}</p>
        </div>
      </div>
      <div class="content"> 
        <small><b>{{coachState}}</b> {{coach.updated_at}}</small>
      </div>
    </div>
    <footer class="card-footer">
      <a class="card-footer-item"
         @click="editCoach"
      >Editar</a>
      <a class="card-footer-item"
         @click="openDeleteModal"
      >{{deleteText}}</a>
      <!-- <a class="card-footer-item" 
         :class="[confirmDelete ? 'is-danger-footer' : '']"
         @click="deleteCoach"
      >{{deleteText}}</a> -->
    </footer>
  </div>
</template>

<script>
  import ImageComposite from '../Util/ImageComposite'
  import { COACH_IMG_PATH, CONTENT_STATES } from '../../config'
  import Vue from 'vue'
  import CardModal from './CoachDeleteModal'

  const CardModalComponent = Vue.extend(CardModal)

  export default {
    components: {
      ImageComposite,
      CardModal
    },

    props: {
      coach: {}
    },

    data () {
      return {
        confirmDelete: false
      }
    },

    computed: {
      coachState () {
        for (let state of CONTENT_STATES) {
          if (state.id === parseInt(this.coach.state_id)) {
            return state.name
          }
        }
        return null
      },

      deleteText () {
        if (this.confirmDelete) {
          return 'Tem certeza?'
        } else {
          return 'Apagar'
        }
      },

      background () {
        return this.coach.background_path ? COACH_IMG_PATH + this.coach.background_path : null
      },

      foreground () {
        return this.coach.foreground_path ? COACH_IMG_PATH + this.coach.foreground_path : null
      }
    },

    methods: {
      openDeleteModal () {
        let openCardModal = (propsData = {}) => {
          return new CardModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Apagar Coche?',
          id: parseInt(this.coach.id)
        })
      },

      editCoach () {
        window.router.push({ name: 'Coche', params: { id: this.coach.id } })
      },

      deleteCoach () {
        if (this.confirmDelete) {
          this.$store.dispatch('deleteCoach', this.coach.id)
        } else {
          this.confirmDelete = true
          setTimeout(() => {
            this.confirmDelete = false
          }, 4000)
        }
      }
    }
  }
</script>

<style lang="scss">
  .coach-card.card {
    width: 300px !important ;
    margin: 0 10px 10px 0;
  }

  .is-danger-footer {
    background-color: #ff3860;
    color: white;
  }
</style>


// WEBPACK FOOTER //
// CoachCard.vue?2a703924